"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const notification_repository_1 = require("./notification.repository");
const email_service_1 = require("./email.service");
const constants_1 = require("../../../../service-lib/src/lib/constants");
let NotificationService = class NotificationService {
    constructor(notificationRepository, emailService) {
        this.notificationRepository = notificationRepository;
        this.emailService = emailService;
    }
    async sendNotification(dto) {
        const event = await this.notificationRepository.findEventByName(dto.eventType);
        if (!event) {
            throw new Error("Event type not found");
        }
        const mapping = await this.notificationRepository.findTemplateMapping(event, dto.channel);
        if (!mapping) {
            throw new Error("Template mapping not found");
        }
        const rendered = this.renderTemplate(mapping.template.body, dto.parameters);
        let status = constants_1.NOTIFICATION_SUCCESS;
        let error;
        try {
            if (dto.channel === constants_1.NOTIFICATION_EMAIL) {
                await this.emailService.sendEmail(dto.emailId, dto.additionalUserId || [], mapping.template.subject, rendered);
            }
            if (dto.channel === constants_1.NOTIFICATION_IN_APP) {
                const notificationRecord = [];
                dto.userId.forEach(async (userId) => {
                    notificationRecord.push({
                        eventTypeId: event.id, // Assuming `event.id` corresponds to the correct property
                        userId: userId,
                        subject: mapping.template.subject,
                        body: rendered,
                    });
                });
                await this.notificationRepository.saveInApp(notificationRecord);
            }
            // TODO: handle other channels
        }
        catch (err) {
            status = constants_1.NOTIFICATION_FAILED;
            error = err.message;
        }
        const log = await this.notificationRepository.saveLog({
            eventType: event,
            channel: dto.channel,
            status,
            error,
        });
        const userLogRecords = [];
        if (dto.userId && dto.userId.length > 0) {
            dto.userId.forEach(async (userId) => {
                userLogRecords.push({
                    logId: log.id,
                    receiverUserId: userId,
                });
            });
        }
        else if (dto.emailId && dto.emailId.length > 0) {
            dto.emailId.forEach(async (email) => {
                userLogRecords.push({
                    logId: log.id,
                    receiverEmailId: email,
                });
            });
        }
        await this.notificationRepository.saveUserLogRecord(userLogRecords);
        return { status };
    }
    async getNotifications(userId, page, limit, status) {
        try {
            const notifications = await this.notificationRepository.getInAppNotifications(userId, page, limit, status);
            const notificationResult = notifications.map((notification) => ({
                body: {
                    entityType: notification.body.includes(constants_1.NOTIFICATION_COMPANY_ENTITY)
                        ? constants_1.NOTIFICATION_COMPANY_ENTITY
                        : constants_1.NOTIFICATION_OPPORTUNITY_ENTITY,
                    entityId: this.getEntityIdFromNotificationContent(notification.body),
                    content: notification.body,
                },
                createdAt: notification.createdAt,
                deletedAt: notification.deletedAt,
                eventTypeId: notification.eventType,
                id: notification.id,
                statusLid: notification.statusLid,
                subject: notification.subject,
                updatedAt: notification.updatedAt,
                userId: notification.userId,
            }));
            const unreadCount = await this.notificationRepository.countUnreadInAppNotifications(userId);
            return { notification: notificationResult, unreadCount };
        }
        catch (error) {
            console.error("Error fetching notifications:", error);
            throw new Error("Error fetching notifications");
        }
    }
    async checkLatestNotification(notificationId, status) {
        const latestNotification = await this.notificationRepository.findLatestInAppNotification(status);
        const anyNewNotification = notificationId
            ? !!(latestNotification &&
                latestNotification.id > parseInt(notificationId, 10))
            : !!latestNotification;
        return { anyNewNotification };
    }
    async updateReadStatus(notificationId, status, userId) {
        if (status == constants_1.NOTIFICATION_STATUS_READ) {
            await this.notificationRepository.markNotificationRead(notificationId);
        }
        else if (status == constants_1.NOTIFICATION_STATUS_DELETE) {
            await this.notificationRepository.deleteNotification(notificationId);
        }
        const unreadCount = await this.notificationRepository.countUnreadInAppNotifications(userId);
        const data = await this.notificationRepository.findInAppNotificationById(notificationId);
        return { notification: data, unreadCount };
    }
    renderTemplate(body, params) {
        return body.replace(/{{(.*?)}}/g, (_, key) => {
            return params[key.trim()] ?? "";
        });
    }
    getEntityIdFromNotificationContent(content) {
        const match = content.match(/\/(\d+)(?!.*\d)/);
        return match ? parseInt(match[1], 10) : null;
    }
};
exports.NotificationService = NotificationService;
exports.NotificationService = NotificationService = tslib_1.__decorate([
    (0, common_1.Injectable)(),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof notification_repository_1.NotificationRepository !== "undefined" && notification_repository_1.NotificationRepository) === "function" ? _a : Object, typeof (_b = typeof email_service_1.EmailService !== "undefined" && email_service_1.EmailService) === "function" ? _b : Object])
], NotificationService);
